module.exports = __webpack_public_path__ + "static/media/ladyday.2e1113e6.webp";